import React, {useState, useEffect, Fragment} from "react";
import { Link, useHistory } from "react-router-dom";
import {showErrorMsg,showSuccessMsg} from '../helpers/message';
import {showLoading} from '../helpers/loading';
import isEmpty from 'validator/lib/isEmpty';
import isUrl from 'validator/lib/isURL';
import { editutm } from "../api/auth";
import { isAuthenticated } from "../helpers/auth";
import Tooltip from './Tooltip';
import './Dashboard.css';
import { Toast, Form } from 'react-bootstrap'
import ToastContainer from 'react-bootstrap/ToastContainer';

//redux
import {useSelector, useDispatch} from 'react-redux';
import {getLink,getLinks} from '../redux/actions/linkActions';

const queryString = require('query-string');



const UEditUtm = ({match}) => {

const dispatch = useDispatch();

let history = useHistory();

const {link} = useSelector(state=>state.links);

const [count,setCount] = useState(false);
const [result ,setResult] = useState('');


//PARAMS
const linkId = match.params.linkId;

 //COMPONENT STATE PROPERTIES
 const [formData, setFormData] = useState({
    linkId:linkId,
    shortUrl:'',
    longUrl:'',
    sonuc:'',
    title:'',
    utmParamaters:[],
    userId:isAuthenticated()._id,
    source:'',
    medium:'',
    campaign:'',
    term:'',
    content:'',
    successMsg: false,
    errorMsg: false,
    loading: false  
});


const {longUrl, shortUrl,title, userId, source, medium ,campaign,sonuc, term, content, utmParamaters, successMsg, errorMsg, loading } = formData;
//const [shortUrl, setShortUrl] = useState('');


 //LIFECYCLE METHODS

 useEffect(() => {
    
    if(!link){
        dispatch(getLink(linkId));
    } 
    else {
        
        setFormData({
            ...formData,
            shortUrl:link.shortUrl,
            longUrl:link.longUrl,
            title:link.title,
            utmParamaters: link.utmParamaters,
            
        });
        
    }

 }, [dispatch, linkId, link])

 

// useEffect(() => {
//     if(isAuthenticated() && isAuthenticated().role === 1) {
//         history.push('/admin/dashboard/');
//     } else if (isAuthenticated() && isAuthenticated().role === 0){
//         history.push('/user/dashboard/');
//     }
// },[history]);

useEffect(() => {
    utmParamaters.map((p) => {
        const { source, medium, campaign, term, content } = p;
        setFormData({
            ...formData,
            source:source,
            medium:medium,
            campaign:campaign,
            term:term,
            content:content,
        });
        
      });
}, [utmParamaters])


useEffect(() => {


   let urlObject = queryString.stringify({source: source, medium: medium, campaign: campaign, term: term, content: content}, { skipNulls: true, skipEmptyString: true });


    function filterNonNull(obj) {
        return Object.fromEntries(Object.entries(obj).filter(([k, v]) => v));
    }

    // let parsedQuery = queryString.stringify(filterNonNull(urlObject2), {
    //     skipEmptyString: true,
    //     skipNull: true
    // });

    // console.log(parsedQuery)

    if(source=='' && medium=='' && campaign=='' && term=='' && content==''){
        
        setResult(longUrl)
        setCount(true);
        
    }
    else {
        setResult(`${longUrl}?${urlObject}`);
        setCount(true);
    }
    
        
}, [formData])

useEffect(() => {
    
        setFormData({
            ...formData,
            sonuc:result,
        });
     
}, [count])




 // COMPONENT GLOBAL STATE PROPERTIES 


const [clientSideErrorMsg,setClientSideErrorMsg] = useState('');
const [clientSideSourceErrorMsg,setClientSideSourceErrorMsg] = useState('');
const [clientSideMediumErrorMsg,setClientSideMediumErrorMsg] = useState('');
const [clientSideCampaignErrorMsg,setClientSideCampaignErrorMsg] = useState('');
const [clientSideTermErrorMsg,setClientSideTermErrorMsg] = useState('');
const [clientSideContentErrorMsg,setClientSideContentErrorMsg] = useState('');
const [clientSideSurlMsg,setClientSideSurlMsg] = useState('');
const [clientSideSucMsg,setClientSideSucMsg] = useState('');
const [showToast, setToast] = useState(false);


        // EVENT HANDLER

        const handleChange = (evt) => {
            //console.log(evt);
    
            

            if (isUrl(evt.target.value)){
                setClientSideErrorMsg('true');
            }  if (!isUrl(evt.target.value)) {
                setClientSideErrorMsg('false');
            }  if (isEmpty(evt.target.value)){
                setClientSideErrorMsg('false');
            } 
            
        } ;

        const handleSource = (evt) => {
            setClientSideSourceErrorMsg('');

            setFormData({
                ...formData,
                [evt.target.name]: evt.target.value,
                //longUrl: `${longUrl}${evt.target.value}`
            });
            setCount(false);

            setClientSideSurlMsg('');
            
             if (isEmpty(evt.target.value)){
                //setClientSideSourceErrorMsg('false');
            } 
            if (!isEmpty(evt.target.value)){
                //setClientSideSurlErrorMsg('true');
                // setClientSideSurlMsg('');
                // setClientSideSurlErrorMsg('');
                
            } 
            
        } ;

        const handleMedium = (evt) => {

            setFormData({
                ...formData,
                [evt.target.name]: evt.target.value,
                
            });
            setCount(false);

            setClientSideSurlMsg('');
            
            
            if (!isEmpty(evt.target.value)){
                //setClientSideSurlErrorMsg('true');
                // setClientSideSurlMsg('');
                // setClientSideSurlErrorMsg('');
            } 
            
        } ;

        const handleCampaign = (evt) => {

            setFormData({
                ...formData,
                [evt.target.name]: evt.target.value,
                
            });
            setCount(false);

            setClientSideSurlMsg('');
            
            
            if (!isEmpty(evt.target.value)){
                //setClientSideSurlErrorMsg('true');
                // setClientSideSurlMsg('');
                // setClientSideSurlErrorMsg('');
            } 
            
        } ;

        const handleTerm = (evt) => {

            setFormData({
                ...formData,
                [evt.target.name]: evt.target.value,
                
            });
            setCount(false);


            setClientSideSurlMsg('');
            
            
            if (!isEmpty(evt.target.value)){
                //setClientSideSurlErrorMsg('true');
                // setClientSideSurlMsg('');
                // setClientSideSurlErrorMsg('');
            } 
            
        } ;

        const handleContent = (evt) => {

            setFormData({
                ...formData,
                [evt.target.name]: evt.target.value,
            });

            setClientSideSurlMsg('');
            
            setCount(false);

            if (!isEmpty(evt.target.value)){
                //setClientSideSurlErrorMsg('true');
                // setClientSideSurlMsg('');
                // setClientSideSurlErrorMsg('');
            } 
            
        } ;


        const handleSubmit = async (evt) => {
            evt.preventDefault();

        // client-side validation
        // setFormData({
        //     ...formData,
        //     longUrl:result
        // });

        

        editutm(formData)
                        .then(response => {
                            if(response.data.successMessage){
                                                setFormData({
                                                    ...formData,
                                                    successMsg:response.data.successMessage
                                                })
                                                setTimeout(() => {
                                                    dispatch(getLinks(userId));
                                                    history.go("/user/dashboard/");
                                                }, 2000);
                                                
                                            }
                                        
                                        setClientSideSurlMsg('');
                                        setClientSideErrorMsg('');
                                    })
                                      
                .catch(err => {
                    console.log('edit utm error:' , err);
                    setClientSideSurlMsg(err.response.data.errorMessage);

                }) 

        }

        const unsecuredCopyToClipboard = (text) => { const textArea = document.createElement("textarea"); textArea.value=text; document.body.appendChild(textArea); textArea.focus();textArea.select(); try{document.execCommand('copy')}catch(err){console.error('Unable to copy to clipboard',err)}document.body.removeChild(textArea)};
        const copyToClipboard = (content) => {
            if (window.isSecureContext && navigator.clipboard) {
              navigator.clipboard.writeText(content);
            } else {
              unsecuredCopyToClipboard(content);
            }
          };

        const protocol = window.location.protocol;
        const domain = window.location.hostname;
        const port = window.location.port;
        const baseurl = `${protocol}//${domain}${port? port : ""}`

        

        return (
            <Fragment>
            <header class="bg-surface-primary border-bottom pt-6">
            <div class="container-fluid">
                <div class="mb-npx">              
                    <div className='row'>
                    <div class="row mb-2">
                                            <div class=" ml-2">

                                            {isUrl(longUrl) && 
                                            <img src={`https://s2.googleusercontent.com/s2/favicons?domain=${longUrl}`}/>
                                            }
                                            {!isUrl(longUrl) && 
                                            <img src={``}/>
                                            }  
                                            
                                            <b> &nbsp; {title && title} </b>
                                            
                                            
                                            
                                                
                                            </div>
                        </div>
                    <div class="row">
                                            <div class="col ml-2 mb-2">
                                        
                                            
                                             <small>{longUrl && longUrl}</small>
                                                                                
                                            </div>
                        </div>
                    <div class="row">
                                            <div class="col">
                                            <Link to={{pathname: `${baseurl}/${shortUrl}`}} target="_blank" >{baseurl}/{shortUrl}</Link>
                                            <Tooltip content="Copy link" direction="top" delay="0">
                                                
                                                <i className="fas fa-clone ms-2" onClick={() => {copyToClipboard(`${baseurl}/${shortUrl}`);setToast(true)}}></i>
                                                
                                            </Tooltip>
                                            </div>
                                            <div class="col">
                                            </div>
                                    
                        </div>
                    </div>
                    
                    <ul class="nav nav-tabs mt-4 overflow-x border-0">
                        <li class="nav-item ">
                            <a href={`/edit/${linkId}`} class="nav-link font-regular">Title</a>
                        </li>
                        <li class="nav-item">
                            <a href={`/edit/alias/${linkId}`} class="nav-link font-regular">Alias Name</a>
                        </li>
                        <li class="nav-item">
                            <a href={`/edit/target/${linkId}`} class="nav-link font-regular">Target Url</a>
                        </li>
                        <li class="nav-item">
                            <a href={`/edit/mobiletarget/${linkId}`} class="nav-link font-regular">Mobile Redirect</a>
                        </li>
                        <li class="nav-item">
                            <a href={`/edit/password/${linkId}`} class="nav-link font-regular">Password</a>
                        </li>
                        <li class="nav-item">
                            <a href={`/edit/utm/${linkId}`} class="nav-link active">UTM Generator</a>
                        </li>
                        <li class="nav-item">
                            <a href={`/edit/expiration/${linkId}`} class="nav-link font-regular">Expiration</a>
                        </li>
                        <li class="nav-item">
                            <a href={`/edit/qr/${linkId}`} class="nav-link font-regular">QR Code</a>
                        </li>
                    </ul>
                </div>
            </div>
            </header>
            <main class="py-6 bg-surface-secondary">
            <div class="container-fluid max-w-screen-md vstack gap-6">
                
                <div class="card">
                <div class="card-body">
                <div class="mb-1">
                <h4 class="mb-1">UTM Generator</h4><p class="text-sm text-muted">Track digital marketing campaigns using short link. Add UTM tags to see traffic data in Google Analytics etc.
</p>
                </div>

            <div class="modal-body">
                        <form onSubmit={handleSubmit} >
                        
                        <label for="recipient-name" class="col-form-label">&nbsp; Source | utm_source:</label>
                        &nbsp;
                        <Tooltip content="E.g google, instagram, twitter, tiktok, facebook, newsletter..." direction="right" delay="0">
                        <i className="fas fa-circle-info"></i>
                        </Tooltip>
                        <div class="input-group mb-2">
                        {clientSideSourceErrorMsg==='false' ? 
                            ( <input type="text" class="form-control form-control-lg is-invalid" name="source" value={source} onChange={handleSource} aria-describedby="basic-addon3" />) 
                            : 
                            clientSideSourceErrorMsg==='true' ?  
                            ( <input type="text" class="form-control form-control-lg is-valid" name="source" value={source} onChange={handleSource} aria-describedby="basic-addon3"/>) 
                              : 
                              ( <input type="text" class="form-control" id="basic-url" name="source" value={source} onChange={handleSource} aria-describedby="basic-addon3"/>) 
                            }

                        </div>

                        
                        <label for="recipient-name" class="col-form-label">&nbsp; Medium | utm_medium:</label>
                        &nbsp;
                        <Tooltip content="E.g banner, email, sms, cpc..." direction="right" delay="0">
                        <i className="fas fa-circle-info"></i>
                        </Tooltip>
                        <div class="input-group mb-2">
                        {clientSideMediumErrorMsg==='false' ? 
                            ( <input type="text" class="form-control form-control-lg is-invalid" name="medium" value={medium} onChange={handleMedium} aria-describedby="basic-addon3" />) 
                            : 
                            clientSideMediumErrorMsg==='true' ?  
                            ( <input type="text" class="form-control form-control-lg is-valid" name="medium" value={medium} onChange={handleMedium} aria-describedby="basic-addon3"/>) 
                              : 
                              ( <input type="text" class="form-control" id="basic-url" name="medium" value={medium} onChange={handleMedium} aria-describedby="basic-addon3"/>) 
                            }
                        
                        </div>
                        
                        <label for="recipient-name" class="col-form-label">&nbsp; Campaign Name | utm_campaign:</label>
                        &nbsp;
                        <Tooltip content="E.g campaign_name, slogan, app_download_campaign... " direction="right" delay="0">
                        <i className="fas fa-circle-info"></i>
                        </Tooltip>
                        <div class="input-group mb-2">
                        {clientSideCampaignErrorMsg==='false' ? 
                            ( <input type="text" class="form-control form-control-lg is-invalid" name="campaign" value={campaign} onChange={handleCampaign} aria-describedby="basic-addon3" />) 
                            : 
                            clientSideCampaignErrorMsg==='true' ?  
                            ( <input type="text" class="form-control form-control-lg is-valid" name="campaign" value={campaign} onChange={handleCampaign} aria-describedby="basic-addon3"/>) 
                              : 
                              ( <input type="text" class="form-control" id="basic-url" name="campaign" value={campaign} onChange={handleCampaign} aria-describedby="basic-addon3"/>) 
                            }
                        
                        </div>
                        <i className="fas fa-regtangle-ad"></i>
                        <label for="recipient-name" class="col-form-label">&nbsp; Campaign Term | utm_term:</label>
                        &nbsp;
                        <Tooltip content="E.g Paid keywords (meditation+app)... " direction="right" delay="0">
                        <i className="fas fa-circle-info"></i>
                        </Tooltip>
                        <div class="input-group mb-2">
                        {clientSideTermErrorMsg==='false' ? 
                            ( <input type="text" class="form-control form-control-lg is-invalid" name="term" value={term} onChange={handleTerm} aria-describedby="basic-addon3" />) 
                            : 
                            clientSideTermErrorMsg==='true' ?  
                            ( <input type="text" class="form-control form-control-lg is-valid" name="term" value={term} onChange={handleTerm} aria-describedby="basic-addon3"/>) 
                              : 
                              ( <input type="text" class="form-control" id="basic-url" name="term" value={term} onChange={handleTerm} aria-describedby="basic-addon3"/>) 
                            }
                        
                        </div>
                        <i className="fas fa-regtangle-ad"></i>
                        <label for="recipient-name" class="col-form-label">&nbsp; Campaign Content | utm_content:</label>
                        &nbsp;
                        <Tooltip content="E.g campaign_name, slogan, app_download... " direction="right" delay="0">
                        <i className="fas fa-circle-info"></i>
                        </Tooltip>
                        <div class="input-group mb-2">
                        {clientSideContentErrorMsg==='false' ? 
                            ( <input type="text" class="form-control form-control-lg is-invalid" name="content" value={content} onChange={handleContent} aria-describedby="basic-addon3" />) 
                            : 
                            clientSideContentErrorMsg==='true' ?  
                            ( <input type="text" class="form-control form-control-lg is-valid" name="content" value={content} onChange={handleContent} aria-describedby="basic-addon3"/>) 
                              : 
                              ( <input type="text" class="form-control" id="basic-url" name="content" value={content} onChange={handleContent} aria-describedby="basic-addon3"/>) 
                            }
                        
                        </div>
                        {clientSideSurlMsg && showErrorMsg(clientSideSurlMsg)}
                        {successMsg && showSuccessMsg(successMsg)}
                    <div class="modal-footer pt-3 justify-content-between">
                        <button type='submit' name="submit" value="submit" id="submit" class="btn btn-primary btn-lg">Save</button>
                    </div>
                    </form>
                    </div>
               
            </div>
            </div>
            </div>

                             {/* // Toast Container */}
                        <div>
                                    <ToastContainer className="p-3" position='bottom-end'>
                                    <Toast
                                        onClose={() => setToast(false)}
                                        autohide
                                        show={showToast}
                                        delay={3000}
                                    >
                                        <Toast.Header>
                                        <strong className="mr-auto">muud.ly</strong>
                                        
                                        </Toast.Header>
                                        <Toast.Body>URL has been copied.</Toast.Body>
                                    </Toast>
                                    </ToastContainer>
                        </div>
                            
                  
                    </main>
                
            </Fragment>
        );
        
    };

export default UEditUtm;